import { render, staticRenderFns } from "./newExamTopicLayoutDialog.vue?vue&type=template&id=080c3bb3&scoped=true"
import script from "./newExamTopicLayoutDialog.vue?vue&type=script&lang=js"
export * from "./newExamTopicLayoutDialog.vue?vue&type=script&lang=js"
import style0 from "./newExamTopicLayoutDialog.vue?vue&type=style&index=0&id=080c3bb3&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c3bb3",
  null
  
)

export default component.exports